module.exports = __webpack_public_path__ + "media/application/images/icons/test-0f96b2e4b1530ccdbbe1c4b7f4015f75.svg";